/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import Button from '../common/Button';
import QuestionHead from './QuestionHead';
import VSB_CHL_IND_01 from '../../img/VSB_CHL_IND_01.jpg';
import BB_IND_01 from '../../img/BB_IND_01.jpg';
import Footer from '../common/Footer';

const images = { VSB_CHL_IND_01, BB_IND_01 };

function DoubleChoice({
  body, buttons, onClick, head, addInfo, image,
}) {
  function handleClick(event) {
    event.preventDefault();
    const { target } = event;
    const button = buttons.find(x => x.label === target.name);
    onClick(button);
  }

  function getBodyMarkup() {
    return { __html: body };
  }

  function getImage() {
    return (
      <img
        className="graph-fluid"
        src={images[image]}
        alt="Shaded Area"
      />
    );
  }

  function renderContent() {
    if (head) {
      return (
        <>
          <QuestionHead head={head} />
          <p dangerouslySetInnerHTML={getBodyMarkup()} />
        </>
      );
    }
    return (
      <>
        <QuestionHead head={body} />
        <p />
      </>
    );
  }

  return (
    <>
      <div className="container mb-4">
        {renderContent()}
        {image && (
          <div className="d-flex justify-content-center">
            {getImage()}
          </div>
        )}
        {addInfo && (
        <p className="font-weight-light font-grayed open-sans">
          <small>{`* ${addInfo}`}</small>
        </p>
        )}
      </div>
      <div className={isMobileOnly ? 'fixed-bottom' : 'container text-center'}>
        {buttons.map(x => (
          <Button
            key={x.label}
            name={x.label}
            label={x.label}
            onClick={handleClick}
            cssClass={isMobileOnly ? 'btn btn-half-width' : 'btn min-width mx-5'}
          />
        ))}
      </div>
      <Footer />
    </>
  );
}

DoubleChoice.propTypes = {
  body: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
  head: PropTypes.string,
  addInfo: PropTypes.string,
  image: PropTypes.string,
};

DoubleChoice.defaultProps = {
  addInfo: null,
  head: null,
  image: null,
};

export default DoubleChoice;
